import React from "react"
import TopNav from "../menu/topnav"
import Menu from "./index"
import { Link } from "gatsby"
import Breadcrumbs from "./breadcrumbs"

export interface NavigationItem {
  id: string
  heading?: string | null | undefined
  title?: string | null | undefined
  url?: string | null | undefined
  links?:
    | ({
        id: string
        url?: string | null | undefined
        title?: string | null | undefined
      } | null)[]
    | null
    | undefined
}

export interface NavigationProps extends Queries.TopNavigationFieldsFragment {
  isTransparent: boolean
  hideNavigation: boolean
  forceBlackTransparentNavigation: boolean | null
  pathName?: string
}

const Navigation = ({
  isTransparent,
  forceBlackTransparentNavigation,
  hideNavigation,
  items,
  hamburger,
  pathName,
}: NavigationProps) => {
  return (
    <div
      className={`c-navigation header ${isTransparent ? "-transparent" : ""} ${
        forceBlackTransparentNavigation
          ? "-forceBlackTransparentNavigation"
          : ""
      }`}
    >
      <div className="c-navigation__inner-wrapper o-wrapper u-flex">
        <div className="c-navigation__logo-wrapper">
          <Link to="/" className="c-logo o-row">
            <span className="is-visually-hidden">Northvolt</span>
          </Link>
          <Breadcrumbs showFor="desktop" />
        </div>
        {!hideNavigation && (
          <>
            <TopNav items={items} pathName={pathName} />
            <Menu items={items} hamburger={hamburger} />
          </>
        )}
      </div>
    </div>
  )
}

export default Navigation
